import cx from "classnames";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";

import Image from "common/components/Image";
import Icon from "common/components/Icon";
import { Optional } from "common/utils/types";
import { getVividColor, getUserColor } from "common/utils/colors";
import { CalendarResource } from "common/types/scheduler";
import { RESOURCE_ICON_NAME_TO_ICON } from "common/constants/scheduler";

import styles from "../../styles/components/ResourceImage.module.less";

export type ResourceImageProps = {
  resource?: Optional<CalendarResource>;
  content?: React.ReactNode;
  className?: string;
  variant?: "light" | "dark";
};

const ResourceImage = (props: ResourceImageProps) => {
  const { resource, content = "?", className, variant = "light" } = props;
  const name = resource?.provider?.initials || resource?.name.slice(0, 2);
  const src = resource?.provider?.image_url;

  const classNames = cx(styles.image, styles[variant], className);

  if (src) {
    return <Image className={classNames} src={src} alt={name ?? "provider"} />;
  }
  const getIcon = () => {
    if (resource?.icon) {
      return RESOURCE_ICON_NAME_TO_ICON[resource.icon];
    }

    if (resource?.is_imported) {
      return faFileImport;
    }

    return null;
  };

  const color = resource?.provider ? getUserColor(resource.provider.user_id) : null;
  const icon = getIcon();
  const text = name || content;

  return (
    <div className={cx(classNames, color && styles[getVividColor(color)])}>
      {icon ? <Icon icon={icon} /> : text}
    </div>
  );
};

export default ResourceImage;
